import React, { Fragment } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import { TbEditCircle } from 'react-icons/tb';
import { TiDocumentDelete } from 'react-icons/ti';
import { useMutation, useQuery } from 'react-query';
import { useAdminSelector, useAdminDispatch } from 'admin-app/redux/admin.store';
import { buildFiltersQuery, goToPage } from 'admin-app/redux/reporting-filter.slice';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import CommonTable from 'components/CommonTable';
import ReportHeader from '../comps/ReportHeader';
import useModal from 'hooks/useModal';
import DeleteInputPrompt from "components/DeleteInputPrompt";
import { PersianDate } from 'helpers/dates';
import { openLink } from 'helpers/general';
import { getProductsReport, deleteProductItem, getProvinceExcelReport } from 'network/apis/ReportingApi';
import { EmptyLabel } from 'components/CommonWidgets';
import HoverText from 'components/HoverText';

const cols = [
	'حذف',
	// 'ویرایش',
	'توضیحات',
	'تاریخ ثبت',
	'کاربر ثبت کننده',
	'واحد',
	'مقدار',
	'نوع ترکیب',
	'ردیف'
];

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.loading {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
		min-height: 30rem;
	}
	  
	div.header-card {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;
	}
`;

const ProductReportTab = ({ currentTab = 'product-report' }) => {
	const filterState = useAdminSelector((store) => store.reportingFilter);
	const dispatch = useAdminDispatch();

	const {
		isOpen: isDeleteModalOpen,
		handleOpenModal: handleOpenDeleteModal,
		handleCloseModal: handleCloseDeleteModel,
		data: deleteModalData,
	} = useModal();

	const { data, refetch, isLoading } = useQuery(
		["get-products-report-tab", filterState.productsReportFilter],
		() => getProductsReport(filterState.productsReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'product-report'
		}
	);

	const getListItems = () => data?.list?.data?.items ?? [];
	const getStatistics = () => data?.statistics?.data;
	const isEmpty = () => getListItems().length < 1;

	const deleteMutation = useMutation(deleteProductItem, {
		onSuccess: (res) => {
			if (res && res.status === 204) {
				toast(`با موفقیت حذف گردید`, {
					type: "success",
					position: "bottom-right",
				});

				refetch();
			}
		},
		onError: () => {
			toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
				type: "error",
				position: "bottom-right",
			});
		},
	});

	const { refetch: fetchTableExcel } = useQuery(
		["get-table-excel", filterState.productsReportFilter],
		() => getProductsReport(filterState.productsReportFilter + 'excel=true'),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.list?.data?.url;
				if (url) openLink(url);
			},
		}
	);

	const { refetch: fetchProvinceExcel } = useQuery(
		["get-province-excel", filterState.productsReportFilter],
		() => getProvinceExcelReport('concentrate', '&' + filterState.productsReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.data;
				if (url) openLink(url);
			},
		}
	);

	const downloadTableExcel = () => {
		fetchTableExcel();
	};

	const downloadProvinceExcel = () => {
		fetchProvinceExcel();
	};

	return (
		<Holder>
			{isLoading ? (
				<div className="loading">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				<Fragment>
					<div className="header-card">
						<ReportHeader
							data={getStatistics()}
							currentTab='product-report'
							onDownloadTableExcel={downloadTableExcel}
							onDownloadProvinceExcel={downloadProvinceExcel}
						/>
					</div>
					{!isEmpty() ? (
						<CommonTable
							cols={cols}
							pageCount={parseInt(data?.list?.data?.num_pages ?? 1)}
							pageOffset={filterState.pageOffset - 1}
							fetchPageAt={(pageOffset) => {
								dispatch(goToPage(pageOffset));
								dispatch(buildFiltersQuery());
							}}
						>
							{getListItems().reduce((allItems, item) => {
								let indexCounter = allItems.length;
								item.items.forEach((productItem) => {
									indexCounter += 1;

									allItems.push((
										<tr key={`${item?.conc_id}-${productItem.item_id}`}>
											<td>
												<TiDocumentDelete
													onClick={() => {
														handleOpenDeleteModal(productItem);
													}}
												/>
											</td>
											{/* <td>
												<TbEditCircle onClick={() => {
													// onEditTap?.(item);
												}} />
											</td> */}
											<td>
												<HoverText>{item?.description ?? '-'}</HoverText>
											</td>
											<td>{new PersianDate(item?.created_at).getParts().join('/')}</td>
											<td>{item?.created_by?.full_name}</td>
											<td>{productItem?.unit?.name}</td>
											<td>{`${productItem?.amount ?? 0}`.persianCurrency()}</td>
											<td>{productItem?.food_item?.name}</td>
											<td>{indexCounter}</td>
										</tr>
									));
								});

								return allItems;
							}, [])}
						</CommonTable>
					) : (
						<EmptyLabel>
							رکوردی ثبت نشده است
						</EmptyLabel>
					)}
					{isDeleteModalOpen && (
						<DeleteInputPrompt
							isOpen={isDeleteModalOpen}
							onClose={handleCloseDeleteModel}
							onActionTap={(warehouseSelected) => {
								handleCloseDeleteModel();
								deleteMutation.mutate({ id: deleteModalData?.item_id, warehouseSelected: false });
							}}
						/>
					)}
				</Fragment>
			)}
		</Holder>
	);
};

export default ProductReportTab;